import { MainActions, MAIN_ACTION_TYPE } from './main-type';
import { RootState } from '../redux/root-reducer';
import { MASTER_DATA_TYPE } from './main-constant';

export enum MAIN_STATE_KEY {
  MASTER_DATA = 'MASTER_DATA',
  HEADER_MENU = 'HEADER_MENU',
  MASTER_DATA_STATUS = 'MASTER_DATA_STATUS',
  LOADING = 'LOADING'
}

export type MainState = {
  [MAIN_STATE_KEY.MASTER_DATA]: any,
  [MAIN_STATE_KEY.HEADER_MENU]?: number,
  [MAIN_STATE_KEY.MASTER_DATA_STATUS]: MASTER_DATA_TYPE,
  [MAIN_STATE_KEY.LOADING]?: { [key: string]: boolean }
};

const initialState: MainState = {
  [MAIN_STATE_KEY.HEADER_MENU]: 0,
  [MAIN_STATE_KEY.MASTER_DATA]: undefined,
  [MAIN_STATE_KEY.MASTER_DATA_STATUS]: MASTER_DATA_TYPE.BLANK,
  [MAIN_STATE_KEY.LOADING]: {}
};

export const mainReducers = (state = initialState, action: MainActions) => {
  switch (action.type) {
    case MAIN_ACTION_TYPE.SET_MAIN_STATE:
      return {
        ...state,
        [action.payload.key]: action.payload.value
      };
    case MAIN_ACTION_TYPE.SET_MAIN_LOADING:
      const newState = {
        ...state,
        [MAIN_STATE_KEY.LOADING]: {
          ...state[MAIN_STATE_KEY.LOADING],
          [action.payload.key]: true
        }
      };
      if (!action.payload.value) {
        delete newState[MAIN_STATE_KEY.LOADING][action.payload.key];
      }
      return newState;
    default:
      return state;
  }
};

export const mainStateSelector = (key: MAIN_STATE_KEY) => (state: RootState) => state.main[key];
